module.exports = __webpack_public_path__ + "img/3.a5a2280a.png";